<div class="animated fadeIn rounded">
    <div class="card">
        <div class="card-header">
            <i class="fa fa-archive"></i> Transacciones Salesforce
            <div class="card-header-actions btn-group" dropdown placement="bottom left">
                <button class="btn btn-sm btn-outline-success" type="button" (click)="exportExcel()">
                    <i class="fa fa-regular fa-file-excel"></i>&nbsp;Exportar a Excel
                </button>
            </div>
        </div>
        <div class="card-body">
            <pos-table tableFormId="productTableId" [headers]="getLogHeaders()" [filters]="getProductFilterColumns()"
                [data]="logs" [itemsPerPage]="15" (dataChange)="getLogData($event)" [badgeDangerValues]="['FAILED',
                'SKIPPED',
                'DELETED',
                'SELLERWITHOUTBRANCHES',
                'CUSTOMERNOTEXISTS',
                'CONTRACTNOTEXISTS',
                'FISCALIDEMPTY',
                'OTHER',
                'UPDATEOPORTUNITY',
                'UPDATEORDER',
                'DATEGREATERTHANALLOW',
                'JSONPARSERERROR',
                'DATETASKGREATERTHAN',
                'DUEDATELESSTHANNOW',
                'OPPORTUNITYNOALLOWCHANGE',
                'PRICEBOOKENTRYNOTFOUND',
                'NAMELONG',
                'ORDERNOTFOUND',
                'UNABLEEXCLUSIVEACCESS']"
                [badgeWarningValues]="['PREAPPROVE', 'CREDITREQUEST','PROCESSING','SENDFORCSV','SKIPED']"
                [badgeSecondaryValues]="['CREATECUSTOMER','TICKET','UNPROCESSED']">
            </pos-table>
        </div>
    </div>
</div>